import { BookPlus, FilePlus, Search } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * Wiki's app-wide palette entries (I-2348): a new page or space — the wiki's
 * `WikiWorkspace` opens the dialog for `?new=page|space` — and a search that
 * asks for the words first. Texts come from the wiki's own table.
 */
export const wikiCommands: CommandFactory = ({ router, t, appLabel: wiki }) => [
  appLocationCommand(router, {
    id: 'wiki.newPage',
    app: 'wiki',
    group: wiki,
    label: `${wiki}: ${t('wiki.page.new')}`,
    href: '/wiki?new=page',
    icon: FilePlus,
    keywords: ['wiki', 'seite', 'page', 'neu', 'new', 'anlegen'],
  }),
  appLocationCommand(router, {
    id: 'wiki.newSpace',
    app: 'wiki',
    group: wiki,
    label: `${wiki}: ${t('wiki.sidebar.new_space')}`,
    href: '/wiki?new=space',
    icon: BookPlus,
    keywords: ['wiki', 'bereich', 'space', 'neu', 'new', 'anlegen'],
  }),
  {
    id: 'wiki.search',
    label: `${wiki}: ${t('wiki.command.search')}`,
    group: wiki,
    app: 'wiki',
    icon: Search,
    category: 'action',
    keywords: ['wiki', 'suchen', 'durchsuchen', 'search', 'volltext'],
    run: () => {
      void router.push('/wiki/search');
    },
    input: {
      placeholder: t('wiki.search.placeholder'),
      run: (query) => {
        const q = query.trim();
        void router.push(q ? { path: '/wiki/search', query: { q } } : '/wiki/search');
      },
    },
  },
];
